export default __webpack_public_path__ + "static/media/discover.cf324c4a.svg";